import { ParsedQuery } from 'query-string'
import { FilterParam } from '../../components/Reusable/IndexPage/FilterBar/FilterBar.types'

export enum GrcDashboardTab {
  COMPLIANCE = 'compliance',
  OE_OVERVIEW = 'oe_overview',
  OE_DETAIL = 'oe_detail',
  RISK_RESPONSE = 'risk_response',
}

export enum GrcDashboardQueryParam {
  ACTIVE_TAB = 'active_tab',
}

export enum ComplianceDashboardQueryParam {
  COMPLIANCE_CHECKLIST_TAB = 'compliance_checklist_tab',
  STATUS_OF_CONTROLS_TAB = 'status_of_controls_tab',
}

export type ComplianceDashboardQuery = ParsedQuery & {
  [ComplianceDashboardQueryParam.COMPLIANCE_CHECKLIST_TAB]?: ChecklistFilterEnum
  [ComplianceDashboardQueryParam.STATUS_OF_CONTROLS_TAB]?:
    | FilterParam.DEPARTMENT
    | FilterParam.OWNER
    | FilterParam.POLICY
}

export enum ChecklistFilterEnum {
  TEAM_WORK = 'team_work',
  YOUR_WORK = 'your_work',
}
